import axios from "./axiosInstance";
import { url } from "./url"; // ✅ use baseURL manually

// Fetch limited blog list (homepage or featured)
export const fetchBlogList = async (limit = 3, page = 1) => {
  try {
    const response = await axios.post(`${url.apiUrl}public/blog/list`, {
      filter: {},
      sort: "desc",
      sortBy: "createdAt",
      skip: 0,
      limit,
      page,
    });

    return response.data?.list || [];
  } catch (error) {
    console.error("Error fetching blog list:", error);
    return [];
  }
};

// Fetch paginated blog list (used with Load More)
export const fetchBlogListpage = async (limit = 5, page = 1) => {
  try {
    const response = await axios.post(`${url.apiUrl}public/blog/list`, {
      filter: {},
      sort: "desc",
      sortBy: "createdAt",
      skip: (page - 1) * limit, // ✅ proper skip calculation
      limit,
      page,
    });

    return response.data?.list || [];
  } catch (error) {
    console.error("Error fetching paginated blog list:", error);
    return [];
  }
};

// Fetch blog detail by ID
export const fetchBlogDetail = async (blogId) => {
  try {
    const response = await axios.post(`${url.apiUrl}public/blog/get/${blogId}`);
    return response.data?.item || null;
  } catch (error) {
    console.error("Blog Detail Error:", error);
    return null;
  }
};
